/**
 * Enum for communication between HUB and CAM
 */
export enum TEST_COMMAND {
    START = 'START', // start measurement
    STOP = 'STOP', // force stop measurement
    GETSERIAL = 'GETSERIAL', // when HUB asks CAM to provide it's serial number
}
